import { pxToRem } from '../../../../lib';
var treeStyles = {
  root: function root() {
    return {
      display: 'block',
      paddingLeft: "".concat(pxToRem(10))
    };
  }
};
export default treeStyles;